export const submitFeedback = async data => {
  const response = await fetch('api/feedback/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (response.ok) {
    return await response.json();
  }
  console.error(response);
  throw new Error(response.statusText);
};
